<template>
    <component
        :is="is"
        v-if="container.items.length > 1"
        @click="moveActiveItem()"
    >
        <slot />
    </component>
</template>

<script>
import { container } from '@/js/util/carousel';
import dynamicComponent from '@/js/mixins/dynamic-component';

export default {
    name: 'CarouselButton',
    defaultTag: 'button',
    mixins: [dynamicComponent],
    inject: { container },
    props: {
        vector: {
            type: Number,
            required: true,
        },
    },
    methods: {
        moveActiveItem() {
            this.container.$emit('moveActiveItem', this.vector);
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/carousel/CarouselButton.vue